import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  HomeIcon,
  UsersIcon,
  SparklesIcon,
  BookOpenIcon,
  BeakerIcon,
  ShoppingBagIcon,
  ShieldCheckIcon,
  KeyIcon,
  ClockIcon,
  ChartBarIcon
} from '@heroicons/react/24/outline';
import { useAuth } from '../../context/AuthContext';

const navigation = [
  { name: 'Dashboard', href: '/', icon: HomeIcon },
  { name: 'Users', href: '/users', icon: UsersIcon },
  { name: 'Bizus', href: '/bizu', icon: SparklesIcon },
  { name: 'Recipes', href: '/recipes', icon: BookOpenIcon },
  { name: 'Ingredients', href: '/ingredients', icon: BeakerIcon },
  { name: 'Products', href: '/products', icon: ShoppingBagIcon },
];

const adminNavigation = [
  { name: 'Admins', href: '/admins', icon: ShieldCheckIcon, requireAdmin: true },
  { name: 'Activity Log', href: '/activity', icon: ClockIcon, requireAdmin: true },
  { name: 'Analytics', href: '/analytics', icon: ChartBarIcon, requireAdmin: true },
  { name: 'Roles', href: '/roles', icon: KeyIcon, requireSuperAdmin: true },
];

export default function Sidebar({ isOpen }) {
  const { isSuperAdmin, isAdmin } = useAuth();

  const getLinkStyle = (isActive) => ({
    backgroundColor: isActive ? '#3ee851' : 'transparent'
  });

  return (
    <aside className={`fixed inset-y-0 left-0 z-50 bg-gray-900 text-white transition-all duration-300 ${isOpen ? 'w-64' : 'w-20'}`}>
      <div className="flex h-16 items-center justify-center border-b border-gray-800">
        <span className={`text-xl font-bold text-[#3ee851] ${!isOpen && 'hidden'}`}>
          Bizumia Admin
        </span>
        <span className={`text-xl font-bold text-[#3ee851] ${isOpen && 'hidden'}`}>
          B
        </span>
      </div>

      <nav className="mt-4 px-2 overflow-y-auto" style={{ maxHeight: 'calc(100vh - 4rem)' }}>
        <div className="space-y-0.5">
          {navigation.map((item) => (
            <NavLink
              key={item.name}
              to={item.href}
              style={({ isActive }) => getLinkStyle(isActive)}
              className={({ isActive }) =>
                `flex items-center px-3 py-2 rounded-lg transition-colors text-sm font-semibold uppercase ${
                  isActive
                    ? 'text-black'
                    : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                }`
              }
            >
              <item.icon className="h-5 w-5 flex-shrink-0" />
              {isOpen && <span className="ml-3">{item.name}</span>}
            </NavLink>
          ))}
        </div>

        {isAdmin && (
          <>
            <div className={`mt-4 mb-1 px-3 ${!isOpen && 'hidden'}`}>
              <p className="text-xs font-semibold uppercase text-gray-400 tracking-wider">
                Administration
              </p>
            </div>
            <div className="space-y-0.5">
              {adminNavigation
                .filter((item) => {
                  if (item.requireSuperAdmin) return isSuperAdmin;
                  if (item.requireAdmin) return isAdmin;
                  return true;
                })
                .map((item) => (
                  <NavLink
                    key={item.name}
                    to={item.href}
                    style={({ isActive }) => getLinkStyle(isActive)}
                    className={({ isActive }) =>
                      `flex items-center px-3 py-2 rounded-lg transition-colors text-sm font-semibold uppercase ${
                        isActive
                          ? 'text-black'
                          : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                      }`
                    }
                  >
                    <item.icon className="h-5 w-5 flex-shrink-0" />
                    {isOpen && <span className="ml-3">{item.name}</span>}
                  </NavLink>
                ))}
            </div>
          </>
        )}
      </nav>
    </aside>
  );
}
